<style scoped lang="less">
#SuccessfullyReceived {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    background: #fff;

    .successMain {
        width: 100%;
        height: 1104px;
        padding-top: 496px;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: url('../../assets/images/success.png') left center;
        background-size: cover;



        .tips2 {
            height: 32px;
            margin-top: 46px;
            font-size: 28px;
            font-weight: 400;
            color: #111F2C;
            line-height: 32px;
            z-index: 10;
            span{
                color:#2892FF;
            }
        }

        .tips3 {
            position: relative;
            padding-top: 340px;
            text-align: center;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 58px;
            z-index: 11;
        }

        .successBot {
            position: fixed;
            width: 100%;
            height: 63%;
            bottom: -10px;
            left: 0;
            // padding-top: 575px;
            // padding-bottom: 60px;
            display: flex;
            flex-direction: column;
            align-items: center;
            background: url('../../assets/images/success_bot.png') left center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            z-index: 10;
            .experienceNow {
                width: 622px;
                height: 92px;
                line-height: 92px;
                text-align: center;
                background: #fff;
                border-radius: 46px;
                font-size: 34px;
                font-weight: 600;
                color: #2892FF;
                letter-spacing: 1px;
                &.FromApp {
                    margin-bottom: 180px;
                }
            }
            .newUser{
                margin:40px 0 120px;
                color:#fff;
                font-size:22px;
                font-weight:400;
                span{
                    border-bottom:1px solid #fff;
                }
            }
            img {
                position: fixed;
                bottom: 60px;
                width: 192px;
                height: 53px;
            }
        }

    }
}
</style>
<template>
    <div id="SuccessfullyReceived">
        <div class="successMain">
            <div class="tips3" >
                <p>你的账号已创建</p>
                <p>请保持电话畅通，将有工作人员联系你</p>
            </div>
            <div class="successBot">
                <img src="../../assets/images/logo.png" alt="" >
            </div>
        </div>
    </div>
</template>
<script>
 import { crmEvent } from "@/api/report"
 import { GetRequest } from "@/util/util"
 import {Toast} from "vant";
 export default {

    name: "SuccessfullyReceived",
    props: ['successData'],
    components: {

        [Toast.name]: Toast,
    },
    data() {
        this.os = function (){
            var ua = navigator.userAgent,
                isWindowsPhone = /(?:Windows Phone)/.test(ua),
                isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
                isAndroid = /(?:Android)/.test(ua),
                isFireFox = /(?:Firefox)/.test(ua),
                isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
                isPhone = /(?:iPhone)/.test(ua) && !isTablet,
                isPc = !isPhone && !isAndroid && !isSymbian;
            return {
                isTablet: isTablet,
                isPhone: isPhone,
                isAndroid: isAndroid,
                isPc: isPc
            };
        }();
        return {
            FromApp: GetRequest(location.search) && GetRequest(location.search).channel,
            show: true,
            datas: {
                userType:"",
                jumpUrl: '',
                crmData:{},
            },
        }
    },
    watch: {},
    computed: {},
    methods: {
        experience() {
            if (this.FromApp) {
                if (this.os.isPhone || this.os.isAndroid) {
                    console.info("正在唤起App...")
                    // window.open('ssai://com.yx');
                    window.location.href = 'ssai://com.yx'
                    Toast('正在打开松鼠Ai APP...')
                    // const startTime = new Date().getTime()
                    setTimeout(() => {
                        // const endTime = new Date().getTime()
                        // if (endTime - startTime < 3500) { // location.href 暂停js执行 判断时间差
                            window.location.href = "https://datayi.cn/o3Mop0E"
                        // }
                    }, 3000)
                }else {
                    console.log("跳转学习中心")
                    window.location.href = this.datas.jumpUrl
                }
            } else {
                console.log("跳转学习中心")
                window.location.href = this.datas.jumpUrl
            }
            let params={
                studentName:this.datas.crmData.studentName||'',
                studentMobile:this.datas.crmData.studentMobile||'',
                accountId:this.datas.crmData.accountId||'',//推荐人的账号id
                newAccountId:this.datas.crmData.newAccountId||'',//该用户账号id
                schoolId:this.datas.crmData.schoolId||'',
                campusId:this.datas.crmData.campusId||0,
                activityNo:this.datas.crmData.activityNo||'',
                school:this.datas.crmData.school||'',
                channelName:this.datas.crmData.channelName||'',//通道名称
                grade:this.datas.crmData.grade||'',
            }
            crmEvent(params).then(ret => {
                if (ret.code === 200) {
                }
            }).catch(err => {
            })
        },
        jump() {
            window.location.href = "https://learn.classba.cn"
        }
    },
    mounted() {
        this.datas = this.successData
        this.crmData=this.urlData
    },
    created() {},
    onbeforeunload() {

    }
}
</script>
